import type { NextPage } from 'next';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { CompanyLogo } from 'ui/components/company-logo';

const Home: NextPage = () => {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid sx={{ svg: { width: '100px' } }} size={12}>
        <CompanyLogo />
        <Typography variant="h3" gutterBottom>
          Cotizador
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Home;
